import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';
import { useCSS } from '../../lib/hooks.js';

import ActionButton from './ActionButton';

import AppleLogo from '../svg/AppleLogo';
import AppleLabelLogo from '../svg/AppleLabelLogo';
import GooglePlayLogo from '../svg/GooglePlayLogo';
import GooglePlayLabelLogo from '../svg/GooglePlayLabelLogo';

const DownloadAppButton = (props) => {
	useCSS('comp/login_buttons.css');

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const platform = props?.platform || 'android';
	const download_app_url = props?.url ?? false;
	if(!download_app_url) return null;

	let label;
	let subtitle = false;
	let svg_icon = null;
	let knk_icon = null;
	let color = 'black';
	switch(platform) {
		case 'login':
			knk_icon = 'ep-user';
			label = i18n("Go to login");
			subtitle = i18n("Access to join");
			color = 'blue';
			break;

		case 'register':
			knk_icon = 'ep-mail';
			label = i18n("Go to register");
			subtitle = i18n("Create new account");
			color = 'blue';
			break;

		case 'ios':
			svg_icon = <span class="network_login_icon ios_logo_container"><AppleLogo /></span>;
			label = <AppleLabelLogo />;
			subtitle = i18n("Available on the");
			break;

		case 'android':
		default:
			svg_icon = <span class="network_login_icon g_play_logo_container"><GooglePlayLogo /></span>;
			label = <GooglePlayLabelLogo />;
			subtitle = i18n("Get it on", 'uppercase');
			break;
	}

	return (
		<div class={`gui_download_app_button is_${platform}_button`}>
			<ActionButton
				_href={download_app_url}
				_target="_blank"
				svg_icon={svg_icon}
				icon={knk_icon}
				color={color}
				_class={{ other:'gui_is_not_animated' }}
				autotranslate={false}
			>
				<span class="button_contents">
					{(subtitle) && (
						<span class="subtitle whiteColor">{subtitle}</span>
					)}

					<span class="platform_name">{label}</span>
				</span>
			</ActionButton>
		</div>
	)
}

export default injectIntl(DownloadAppButton);